export default __webpack_public_path__ + "static/media/35.677dc760.jpg";